module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/56DaA9bbnGUEeaC0qMkiC4-78a548c3568a9d6ba294fdf3af9238f0.jpg";